import { BackButton } from '@src/common/components/button/BackButton';
import { useTranslation } from 'react-i18next';

import { useCurrentOrderMode } from '../hooks/useCurrentOrderMode';

export const BackToOrderDetails = () => {
  const { t } = useTranslation();
  const { setCurrentMode } = useCurrentOrderMode();

  return (
    <BackButton
      onClick={() => setCurrentMode({ mode: 'summary' })}
      label={t('orderDetails')}
    />
  );
};
